var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prod_item",on:{"click":_vm.selctCurSubGroup}},[_c('div',{staticClass:"img_container"},[(_vm.image != null && _vm.hasImage)?_c('img',{attrs:{"src":_vm.image},on:{"error":function () { return this$1.hasImage = false; }}}):_c('img',{attrs:{"src":_vm.noImageSrc}})]),_vm._v(" "),_c('div',{staticClass:"name_container"},[_c('div',{staticClass:"container"},[_c('span',{staticClass:"name",domProps:{"textContent":_vm._s(_vm.name)}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7263ceb2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubGroupCardGom.vue
// module id = null
// module chunks = 